import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { injectIntl, defineMessages } from "react-intl";
import { Message, List } from "semantic-ui-react";

import * as adminActions from "modules/admin";
import { Button, ModalTemplate, Loading } from "components";
import "./ConfigSync.css";

class ConfigSyncTest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      resultMessage: { success: "", fail: "" },
    };
  }

  onToggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  // 대상자 쿼리 연결 테스트
  syncQueryTest = async () => {
    this.setState({ onProgress: true });

    const { AdminActions, configParameter } = this.props;
    const params = {
      queryType: configParameter === "userQuery" ? 1 : 2,
    };

    try {
      const response = await AdminActions.postSyncTest(params);
      if (response && !response.data.error) {
        this.setState({
          resultMessage: { success: response.data.list, fail: "" },
        });
      } else {
        this.setState({
          resultMessage: { success: "", fail: response.data.error[0].errInfo },
        });
      }
    } catch (e) {
      console.log("syncQueryTest error", e);
    }

    this.setState({ onProgress: false });
    this.onToggleModal();
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { onProgress, showModal, resultMessage } = this.state;
    const { syncQueryTest, onToggleModal } = this;

    return (
      <div className="config-sync-test">
        {/* 연결 테스트 모달 */}
        {showModal && (
          <ModalTemplate
            closeOnEscape={false}
            closeOnDimmerClick={false}
            className={"modal-admin tiny common-content"}
            visible
            onToggleModal={onToggleModal}
            header={
              <div>
                {defineMessages(
                  formatMessage({
                    id: "SmtpTest_1",
                    defaultMessage: "연결 테스트",
                  })
                )}
              </div>
            }
            buttons={
              <div className={"inline-block"}>
                <Button buttonColor="#bbbbbb" onClick={onToggleModal}>
                  {defineMessages(
                    formatMessage({
                      id: "StartExamWizardButton_4",
                      defaultMessage: "확 인",
                    })
                  )}
                </Button>
              </div>
            }
          >
            <Loading active={onProgress} size="small" content="Waiting..." />
            {resultMessage.success ? (
              <Message className={"template-detail-box"}>
                <div className={"template-detail"}>
                  <List className={"template-detail-list"}>
                    {resultMessage.success.map((item, index) => {
                      return (
                        <List.Item
                          className={"template-detail-item"}
                          key={index}
                        >
                          <div className={"template-detail-item-title"}>
                            {JSON.stringify(item)}
                          </div>
                        </List.Item>
                      );
                    })}
                  </List>
                </div>
              </Message>
            ) : (
              <div className="message-header">{resultMessage.fail}</div>
            )}
          </ModalTemplate>
        )}

        {/* 연결 테스트 */}
        <button className="sync-test-btn" onClick={syncQueryTest}>
          {defineMessages(
            formatMessage({
              id: "SmtpTest_1",
              defaultMessage: "연결 테스트",
            })
          )}
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  //
});

const mapDispatchToProps = (dispatch) => ({
  AdminActions: bindActionCreators(adminActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ConfigSyncTest));



// WEBPACK FOOTER //
// ./src/script/components/config/ConfigSyncTest.js